import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Pregunta.types';
import { IPregunta } from './Pregunta.lib';
import { isNull, isArray } from 'util';

export class Pregunta extends IPregunta
{

    public static async create( id: number ): Promise<Pregunta>
    {
        let o = new Pregunta();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/cursos/preguntas';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Pregunta>; Error?: boolean; }>
    {

        let a: Array<Pregunta> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/cursos/preguntas` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Pregunta( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }



    public async Contestar( opcion: number | number[] ): Promise<boolean>
    {
        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();
                if ( isArray( opcion ) )
                    req.body.opciones = opcion;
                else
                    req.body.opciones = [opcion];

                req.path = `/cursos/${this.Curso}/respuestas/${this.Id}/opciones`;
                if ( await req.post() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }
}